// extracted by mini-css-extract-plugin
export var actions = "_4u-0";
export var actionsContainer = "_4u-6";
export var border = "_4u-1";
export var childFullHeight = "_4u-d";
export var collapse = "_4u-2";
export var content = "_4u-8";
export var contentChild = "_4u-c";
export var fullscreen = "_4u-a";
export var headerContainer = "_4u-3";
export var headerRow = "_4u-5";
export var hidePadding = "_4u-9";
export var noScrollX = "_4u-e";
export var noScrollY = "_4u-f";
export var optOutTopPadding = "_4u-b";
export var pagePadding = "_4u-7";
export var profile = "_4u-g";
export var profileContainer = "_4u-h";
export var profileImage = "_4u-i";
export var profileMain = "_4u-j";
export var profileSubtitle = "_4u-l";
export var profileTitle = "_4u-k";
export var tabsWrapper = "_4u-4";
export var title = "_4u-m";